import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../BaseURL";
import "../Assets/WebsiteCss/Adminglogin.css";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleAdminLogin = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error("Email and password are required");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${BASE_URL}/api/admin/login`, {
        email,
        password,
      });

      const { success, token, message } = response.data;

      if (success) {
        localStorage.setItem("userToken", token);
        toast.success(message || "Login Success!");

        setTimeout(() => {
          navigate("/dashboard");
        }, 100);
      } else {
        toast.error(message || "Login failed");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Something went wrong. Try again.",
      );
    }

    setLoading(false);
  };

  useEffect(() => {
    const token = localStorage.getItem("userToken");
    if (token) {
      navigate("/dashboard");
    }
  }, [navigate]);

  return (
    <Container
      fluid
      className="d-flex justify-content-center align-items-center login-container"
    >
      <Toaster position="top-center" />
      <Row className="w-100 justify-content-center">
        <Col xs={12} md={6} lg={4}>
          <div className="login-form-container">
            <h3 className="login-header">Admin Login</h3>

            <Form onSubmit={handleAdminLogin}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter admin email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="username"
                />
              </Form.Group>

              <Form.Group className="mb-3 position-relative">
                <Form.Label>Password</Form.Label>
                <div className="position-relative">
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter admin password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                  />
                  <button
                    type="button"
                    className="password-toggle-btn"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </Form.Group>

              <Button
                type="submit"
                className="w-100 login-button"
                disabled={loading}
              >
                {loading ? "Logging in..." : "Login"}
              </Button>
            </Form>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default AdminLogin;
